export const removeDuplicateNodes = (graphData) => {
    const uniqueNodes = [];
    const seenDescriptions = new Set();
  
    graphData.nodes.forEach((node) => {
      if (!seenDescriptions.has(node.description)) {
        uniqueNodes.push(node);
        seenDescriptions.add(node.description);
      }
    });
  
    const uniqueNodeIds = new Set(uniqueNodes.map(node => node.id));
    const filteredLinks = graphData.links.filter(
      link => uniqueNodeIds.has(link.source) && uniqueNodeIds.has(link.target)
    );
  
    return { nodes: uniqueNodes, links: filteredLinks, 'color-legend': graphData['color-legend'] };
  };
  